module.exports = __webpack_public_path__ + "img/filomeno.65cb119d.png";